import axios from 'axios';
import { protectedResourcesScopes } from '../../../../../auth/config';
import { acquireToken } from '../../../../../auth/msal';
import { DisciplineEnum } from '../enums/disciplineEnum';
const scope = protectedResourcesScopes.core;
const apiUrl = `${process.env.REACT_APP_BFF_API}`;

export async function getAssetsByDiscipline(
  instance: any,
  queryParams: {
    discipline: DisciplineEnum;
    location: string;
    page?: number;
    limit?: number;
  },
) {
  try {
    const accessToken = await acquireToken(instance, scope);

    const { data } = await axios.get(`${apiUrl}/v2/maintenance/asset`, {
      headers: { Authorization: `Bearer ${accessToken}` },
      params: { ...queryParams },
    });
    return data;
  } catch (e) {
    throw e;
  }
}
